(function () {
    'use strict';

    angular
        .module('core.services')
        .service('AuthenticationService', AuthenticationService)

    /** @ngInject */
    function AuthenticationService($http, $q, $state, $location, $rootScope, PermissionGroupService, $httpParamSerializerJQLike,
        MeService, ROUTES, DATA_EVENTS, LOCAL_STORAGE_ITEMS) {
        let user;
        let userCompanies = [];
        let selectPersonCompany = {};
        let modules = [];
        let permissions = [];

        const AuthenticationService = {
            // Getters
            getUser,
            getCompanies,
            getPermissions,

            // Methods
            updateUser,
            login,
            logout,
            isLogged,
            handleSystemLoad,
            canAccess,
            setCompany,
            configureUserPermissions,
            getCompanyDataByPermissionGroupAndModuleId
        }

        return AuthenticationService;

        // Getters
        function getUser() {
            return {
                Id: user.Id,
                PersonId: selectPersonCompany.PersonId,
                Name: user.Name,
                Image: user.Image,
                PermissionGroupId: selectPersonCompany.PermissionGroup ? selectPersonCompany.PermissionGroup.Id : 0,
                PermissionGroup: selectPersonCompany.PermissionGroup || {},
                ResponsibilityId: selectPersonCompany.Responsibility ? selectPersonCompany.Responsibility.Id : 0,
                Responsibility: selectPersonCompany.Responsibility || {},
                Company: selectPersonCompany.Company || {}
            }
        }

        function getCompanies() {
            return userCompanies;
        }

        function getPermissions() {
            return modules;
        }

        // Methods
        function updateUser(userData) {
            user.Name = userData.Name;
            user.Image = userData.Image;
            user.GenderId = userData.GenderId;

            $rootScope.$broadcast(DATA_EVENTS.USER_UPDATED);
        }

        function login(loginData) {
            return $http.post(`${ROUTES.API}/authorization`, $httpParamSerializerJQLike(loginData), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(response => {
                if (response != null && response != undefined)
                    return response.data;

                return response;
            });
        }

        function logout() {
            localStorage.removeItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);
            localStorage.removeItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_REFRESH);
            localStorage.removeItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_EXPIRATION);
            localStorage.removeItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_OWNER);
            localStorage.removeItem(LOCAL_STORAGE_ITEMS.SELECTED_COMPANY);

            $state.go('app-auth.login');
        }

        function isLogged() {
            const accessToken = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);
            const refreshToken = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_REFRESH);
            const tokenExpiration = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_EXPIRATION);

            return accessToken && refreshToken && moment().diff(tokenExpiration, 'hours') < 12;
        }

        function handleSystemLoad() {
            let defer = $q.defer();
            const accessToken = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);

            if (accessToken) {
                MeService
                    .getMe(accessToken)
                    .then(success => {
                        localStorage.setItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_OWNER, success.Id);

                        prepareUserData(success, defer);

                        $rootScope.hideLoading = true;
                    }, error => {
                        $rootScope.hideLoading = true;

                        defer.reject(error);
                    })
            } else {
                defer.reject({
                    error: 'User token not available from localStorage'
                });
            }

            return defer.promise;
        }

        function canAccess(transitionTo) {
            let canUserAccess = false;

            if (transitionTo.url == '/' || (!transitionTo.isRestricted && !transitionTo.moduleId)) return true;

            if (transitionTo.moduleId) {
                let foundModule = modules.find(module => module.Id == transitionTo.moduleId);

                if (foundModule)
                    canUserAccess = true;
            }

            return canUserAccess;
        }

        function setCompany(companyId, defer) {
            if (!defer)
                defer = $q.defer();

            let state = $state.current;

            let data = user.PersonCompanies.find((x) => {
                return x.CompanyId == companyId;
            });

            if (data) {
                localStorage.setItem(LOCAL_STORAGE_ITEMS.SELECTED_COMPANY, data.CompanyId);

                PermissionGroupService
                    .getPermissions(data.PermissionGroupId)
                    .then(success => {
                        permissions = success;
                        selectPersonCompany = data;

                        modules = permissions.reduce((modules, permission) => {
                            if (!modules.find(x => x.Id == permission.Module.Id)) {
                                let tempModule = permission.Module;

                                tempModule.IsEdit = permission.IsEdit;

                                modules.push(tempModule);
                            }

                            return modules;
                        }, []);

                        configureUserPermissions();

                        if (!canAccess(state)) {
                            defer.reject({
                                error: 'User is not allowed',
                                redirTo: 'app.not-authorized'
                            });
                        } else if (canAccess(state) && $location.path().indexOf('not-authorized') > 0) {
                            defer.reject({
                                error: 'User is allowed, wrong route',
                                redirTo: 'app.home'
                            });
                        } else {
                            defer.resolve(true);
                        }
                    })
                    .catch(() => {
                        defer.reject('Error while recovering user modules');
                    })
            } else
                defer.reject('Error while recovering user local data');

            return defer.promise;
        }

        function configureUserPermissions(state) {
            const currentState = state || $state.current;
            const permission = getUserPermissionsForModule(currentState.moduleId);

            if (currentState.url == '' || !currentState.moduleId) {
                $rootScope.canUserEdit = true;
                return;
            }

            if (!permission) {
                $rootScope.canUserEdit = false;
                return;
            }

            $rootScope.canUserEdit = permission.IsEdit;
        }

        function getCompanyDataByPermissionGroupAndModuleId(permissionGroupId, moduleId) {
            const filteredPersonCompany = user.PersonCompanies.filter(personCompany => {
                if (personCompany.PermissionGroupId == permissionGroupId) {
                    const personCompanyPermissions = getUserPermissionsForModule(moduleId);

                    // If user has permission on the company and has permission to post or put on the informed module
                    if (personCompanyPermissions && (personCompanyPermissions.IsEdit))
                        return personCompany;
                }
            });

            return filteredPersonCompany;
        }

        // Internal
        function prepareUserData(data, defer) {
            userCompanies = [];

            let allowedCompanyId;
            let selectedCompanyId = parseInt(localStorage.getItem(LOCAL_STORAGE_ITEMS.SELECTED_COMPANY));

            if (selectedCompanyId)
                allowedCompanyId = selectedCompanyId;

            for (let i = 0; i < data.PersonCompanies.length; i++) {
                const userCompany = data.PersonCompanies[i];

                if (userCompany.Company)
                    userCompanies.push(userCompany.Company);
            }

            user = data;

            //If we don't have user data or user companies go to not authorized
            if (!user || !userCompanies.length) {
                defer.reject({
                    error: 'User doens\'t have data or companies',
                    redirTo: 'app.not-authorized'
                });

                return defer.promise;
            }

            let allowedData = userCompanies.find(x => (x.Id == allowedCompanyId));

            if (!allowedData)
                allowedCompanyId = userCompanies[0].Id;

            setCompany(allowedCompanyId, defer);
        }

        function getUserPermissionsForModule(moduleId) {
            let availablePermission;

            for (let indexP = 0; indexP < permissions.length; indexP++) {
                const permission = permissions[indexP];

                if (!selectPersonCompany.Company.CompanyIdParent && permission.Module.IsFranchiser && moduleId == permission.ModuleId) {
                    availablePermission = permission;
                } else if (selectPersonCompany.Company.CompanyIdParent && permission.Module.IsFranchisee && moduleId == permission.ModuleId) {
                    availablePermission = permission;
                }
            }

            return availablePermission;
        }
    }
}());